import { lazy } from 'react';

const Users = lazy(() => import('./Users'));

export default Users;
